import { computed, defineComponent, reactive } from 'vue';
import { useStore } from 'vuex';
import { Helper, useModelWrapper, DateHelper } from '@hems/util';
import VCalendar from './VCalendar.vue';
export default defineComponent({
    name: 'CalendarHourly',
    components: {
        VCalendar,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    setup(props, { emit }) {
        const store = useStore();
        const langCd = computed(() => store.state.appCtx.langCd);
        const locale = Helper.getEnvLocale();
        const state = reactive({
            date: useModelWrapper(props, emit),
        });
        return {
            state,
            Helper,
            langCd,
            locale,
            DateHelper,
        };
    },
});
